const initState = {
  sportRequests: [],
  hasMoreDocument: false,
  lastDocument: null,
};

const requestedSportsReducer = (state = initState, action) => {
  switch (action.type) {
    case "GET_SPORT_REQUEST":
      return {
        ...state,
        sportRequests: action.payload.data,
        hasMoreDocument: action.payload.hasMoreDocument,
        lastDocument: action.payload.lastDocument,
      };
    case "GET_SPORT_REQUEST_MORE":
      return {
        ...state,
        sportRequests: [...state.sportRequests, ...action.payload.data],
        hasMoreDocument: action.payload.hasMoreDocument,
        lastDocument: action.payload.lastDocument,
      };
    default:
      return {
        ...state,
      };
  }
};
export default requestedSportsReducer;
